/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Current Stock By Date Context
 * Description: Current Stock By Date Context
 */

import { createContext, useContext, useState } from 'react';

const ContextAPI = createContext({});

export function useCurrentStockByDate() {
    return useContext(ContextAPI);
}

export function CurrentStockByDateProvider({ children }) {
    const [data, setData] = useState();
    const [showPdf, setShowPdf] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseLayer, setResponseLayer] = useState();
    const [stockDate, setStockDate] = useState();
    const [consolidated, setConsolidated] = useState(false);

    return (
        <ContextAPI.Provider
            value={{
                data,
                setData,
                showPdf,
                setShowPdf,
                loading,
                setLoading,
                responseLayer,
                setResponseLayer,
                stockDate,
                setStockDate,
                consolidated,
                setConsolidated,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
